import styled from "styled-components";
import { MEDIA_QUERY } from "../../../entities/Common";

export const LanguageSelectStyled = styled.div`
  width: 160px;
  .language-select {
    &__option {
      display: flex;
      cursor: pointer;
      align-items: center;
    }
    &__img {
      max-width: 30px;
      margin-right: 10px;
    }
  }

  @media (max-width: ${MEDIA_QUERY.TABLET_VERTICAL}) {
    width: 150px;
    font-size: 14px;
  }
`;
